import * as z from "zod";

export const syncShopifyOrders = {
  name: "syncShopifyOrders" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ status: z.string() }),
};
